import {
    Button,
    Grid,
    Switch,
    Tooltip,
    Typography,
    FormControl,
    List,
    ListItem,
    ListItemText,
    IconButton,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import MiniDrawer from "../../Components/Drawer";
  import { getApiData, getApiData2, getbrokeruser, getquizuser } from "../../Apis/apiHelper";
  import BaseSetting from "../../Apis/setting";
  import { toast } from "react-toastify";
  import EditIcon from "@mui/icons-material/Edit";
  import { useNavigate } from "react-router-dom";
  import { DataGrid } from "@mui/x-data-grid";

import { useDispatch, useSelector } from 'react-redux';
const moment = require('moment');
  export default function News() {
    const [rows, setRows] = useState([]);
  
    const  accessToken  = useSelector((state) => state.auth);
    console.log("accessToken==>" ,accessToken.accessToken)
    const navigate = useNavigate();
    useEffect(() => {
      News();
    }, []);
  
    function convertDateFormat(dateString) {
        // Parse the date string using Moment.js
        const date = moment(dateString);
    
        // Format the date into a normal date format
        const normalDateFormat = date.format('YYYY-MM-DD');
    
        return normalDateFormat;
    }

    const handleEdit = (id) => {
      // Perform edit action here using the ID or unique identifier of the row
      console.log(`Editing row with ID: ${id}`);
      navigate(`/productdetails`, { state: { id } });
      // You can open a modal, navigate to a different page, or handle editing logic here
    };
  
    
    async function News() {
        try {
          const authToken = accessToken.accessToken;
          console.log("authToken1234===>", authToken);
      
          // Make the GET request with headers
          const response = await fetch('https://dev.convey.in:5002/api/accounts/findAll', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            }
          });
      
          // Check if the response is unauthorized
          if (response.status === 401) {
            console.log("Unauthorized: Invalid token");
            return;
          }
      
          // Parse response JSON
          const data = await response.json();
          console.log("data====>>>>", data.data.datafetched);
          const receivedRows = data?.data?.datafetched?.map((item, index) => ({
            id: item.id,
            name: item.name,
            emailAddress: "NA",
            mobileNumber: item.phone,
            joinon:convertDateFormat(item.created_at),
            joinedfrom:"NA"
          }));
          // eslint-disable-next-line no-const-assign
          setRows(receivedRows);
      
      
        } catch (error) {
          console.log("ERROR=====>>>>>", error);
          toast(error.toString(), { type: "error" });
          // Handle errors
        }
      }
      
      
      
      
  
    const columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "emailAddress", headerName: "Email Address", width: 250 },
      { field: "mobileNumber", headerName: "MobileNumber", width: 180 },
      { field: "name", headerName: "Name", width: 180 },
   
     
      { field: "joinedfrom", headerName: "Joined from", width: 250 },
    
      
      
      { field: "joinon", headerName: "Joined ON", width: 180 },
     
    
    //   {
    //     width: 50,
    //     renderCell: (params) => (
    //       <IconButton onClick={() => handleEdit(params.row.idd)}>
    //         {" "}
    //         {/* handleEdit function should handle edit action */}
    //         <EditIcon />
    //       </IconButton>
    //     ),
    //   },
    ];
  
    return (
      <Grid container>
        <MiniDrawer
          header="News"
          children={
            <>
              
              {console.log("rows====>>> ", rows)}
              <Grid>
               
                <div style={{ height: 650,width: "100%", paddingTop: 20 }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pageSizeOptions={[10, 15, 20]}
                    // checkboxSelection
                  />
                </div>
                
              </Grid>
            </>
          }
        />
      </Grid>
    );
  }
  